var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m_question"},[_c('div',{staticClass:"issueName"},[_c('span',[_vm._v(_vm._s(_vm.question.title))]),_vm._v(" "),_c('span',{staticClass:"icon-top",on:{"click":_vm.isshow}})]),_vm._v(" "),(_vm.isopen)?_c('div',{staticClass:"issuespan"},[_c('span',[_vm._v(_vm._s(_vm.question.content))])]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b2ca03a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/userCenter/questionitem.vue
// module id = null
// module chunks = 